import React from 'react';
import Header from '../../../Reusable/Header';
import Footer from '../../../Reusable/Footer';
import Hero from './Page components/Impact/Hero';
import useSEO from '../../../../hooks/useSEO';

const Impact = () => {
  useSEO({
    title: 'Our Impact – Campaigns That Changed Lives',
    description:
      'Discover the real-world impact of fundraising campaigns on Yamba Africa. See how donors and campaigners are transforming lives and communities across Africa.',
    url: 'https://yamba.africa/impact',
    keywords:
      'crowdfunding impact Africa, fundraising results Africa, Yamba Africa success stories, charity impact Uganda',
  });

  return (
    <div>
      <Header />
      <Hero />
      <Footer />
    </div>
  );
};

export default Impact;